/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useCallback } from "react";
import clsx from "clsx";
import { showToast } from "../toast";
import AnimateScroll from "./AnimateScroll";
import { Download } from "./Download/Download";
import { ga } from "../ga";

const Header = ({ chains }) => {
  const [isExpand, setIsExpand] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [mouseOver, setMouseOver] = useState("");
  const isFirefox = /firefox/i.test(navigator.userAgent);
  const isBrave = /brave/i.test(navigator.userAgent);
  const isEdge = /edg\//i.test(navigator.userAgent);
  const isChrome = !isBrave && !isEdge && /chrome/i.test(navigator.userAgent);

  const initMouseOver = useCallback(() => {
    if (isChrome) setMouseOver("chrome");
    if (isEdge) setMouseOver("edge");
    if (isBrave) setMouseOver("brave");
    if (isFirefox) setMouseOver("firefox");
  }, [isBrave, isChrome, isEdge, isFirefox]);

  const handleClickMenuBtn = () => {
    setIsExpand(!isExpand);
  };

  const reportClickDownload = (label) => {
    ga.event({
      category: "User",
      action: "clickDownload",
      label,
    });
  };

  // eslint-disable-next-line no-unused-vars
  const handleClickDownloadBtn = (e) => {
    if (/mobile/i.test(navigator.userAgent)) {
      e.preventDefault();
      showToast({
        content: "Please visit this site from the desktop",
        duration: 2000,
      });
    }
    reportClickDownload();
  };

  useEffect(() => {
    initMouseOver();
  }, [initMouseOver]);

  return (
    <header>
      <div className="nav">
        <img
          src="/assets/logos/logo.png"
          style={{ filter: "brightness(0) invert(1)" }}
          alt="Forging block"
          className="logo"
        />
        {/* <a
          href="#"
          className={clsx("menu-btn", {
            expand: isExpand,
          })}
          onClick={handleClickMenuBtn}
        >
          <i></i>
          <i></i>
          <i></i>
        </a>
        <ul className={clsx("menu", { show: isExpand })}>
          <li>
            <a href="#" target="_blank" rel="noreferrer">
              ForgingBlock Kit
            </a>
          </li>
          <li>
            <a href="#" target="_blank" rel="noreferrer">
              Twitter (X)
            </a>
          </li>
          <li>
            <a href="#" target="_blank" rel="noreferrer">
              Medium
            </a>
          </li>

          <li>
            <a href="#" target="_blank" rel="noreferrer">
              Discord
            </a>
          </li>
          <li>
            <a href="#" target="_blank" rel="noreferrer">
              GitHub
            </a>
          </li>
          <li>
            <a href="#" target="_blank" rel="noreferrer">
              Email
            </a>
          </li>
        </ul> */}
      </div>
      <div className="header-content">
        <div className="left">
          <h1 className="white">
            The game-changing wallet for
            <AnimateScroll chains={chains}></AnimateScroll>
          </h1>
          <div className="container">
            <Download />
          </div>
          <img
            src="/assets/images/hero-15.png"
            alt="Dashboard screenshot"
            className="hero-image"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
